import React from 'react';
import Load from 'components/Load';
import basePath from 'utils/basePath';
import PrivateRoute from 'components/PrivateRoute';

const AsyncPayoutContainer = Load(() => import(/* webpackChunkName: "host-payout-methods" */'./containers/Payout'));

const HostPayoutRoutes = [
  <PrivateRoute
    key={'host-payout'}
    path={`${basePath}/host/payout`}
    component={AsyncPayoutContainer}
  />
];

export default HostPayoutRoutes;
